import wrapLabelAndError from '../../behaviors/wrap_label_and_error';
import NumberField from '../NumberField/NumberField';

const NumberFieldWithLabel = wrapLabelAndError(NumberField);

export default NumberFieldWithLabel;
